export default __webpack_public_path__ + "static/media/Uhr_Kasten.584f7e74.svg";